import { Icon } from '@buggy/shared'
import { Button } from 'antd'
import { FunctionComponent } from 'react'
import styled, { useTheme } from 'styled-components'
import PermissionInsufficientTooltip from '@/components/common/permission-insufficient-tooltip'
import { ActionsWrapper } from '@/components/kol/irm/common/action-wrapper'
import { useDirectoryActionPermission } from '@/hooks/use-permission'

interface ActionsProps {
  onEdit?: () => void
  onDelete?: () => void
}

const Actions: FunctionComponent<ActionsProps> = ({ onEdit, onDelete }) => {
  const theme = useTheme()
  const directoryActionPermission = useDirectoryActionPermission()

  return (
    <Wrapper>
      {onEdit && (
        <PermissionInsufficientTooltip
          insufficient={!directoryActionPermission}
        >
          <Button
            disabled={!directoryActionPermission}
            icon={
              <Icon
                color={
                  !directoryActionPermission
                    ? theme.colors.base.grey.grey5
                    : theme.colors.brand.secondary
                }
                fontSize={16}
                name='edit-3'
              />
            }
            type='link'
            onClick={onEdit}
          />
        </PermissionInsufficientTooltip>
      )}
      {onDelete && (
        <PermissionInsufficientTooltip
          insufficient={!directoryActionPermission}
        >
          <Button
            disabled={!directoryActionPermission}
            icon={
              <Icon
                color={
                  !directoryActionPermission
                    ? theme.colors.base.grey.grey5
                    : theme.colors.brand.secondary
                }
                fontSize={16}
                name='trash-2'
              />
            }
            type='link'
            onClick={onDelete}
          />
        </PermissionInsufficientTooltip>
      )}
    </Wrapper>
  )
}

export default Actions

const Wrapper = styled(ActionsWrapper)`
  gap: 16px;
  align-items: center;

  button {
    height: 20px;
    width: 20px !important;
    padding: 0 !important;
  }
`
